const routeNames = {
    'contato':'contato',
    'politica-de-privacidade':'politica-de-privacidade',
}

export default routeNames;